module.exports = __webpack_public_path__ + "static/media/desktop_illustration_side2_side3.35a21f15.png";